import React from 'react';
import { ImageAsset, SVGAsset } from "res";
import "./styles.css";
/**
 * @function BillerTileView 
 * @param {STRING} name - Pass the biller's name to the component.
 * @param {STRING} type - Pass the biller's type to the component.
 * @param {STRING} accountNumber - Pass the biller's account number to the component.
 * @param {React.Component} logo - Pass the asset logo as a React component to the component.
 * @returns {React.Component}
 * @example
 * <BillerTileView name="Biller's name" type="Biller's type" accountNumber="*1234" logo={<ImageAsset id="logoName" />}>
 *  <TableView/>
 * </BillerTileView>
 */
export default function BillerTileView(props) {
    const name = props.name ?? "[BillerName]";
    const type = props.type ?? "";
    const accountNumber = props.accountNumber ?? "[*1234]";
    const logo = props.logo ?? "";
    const className = props.className ?? "";

    const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};

    return (
      <div className={className + " flex-container flex-vertical biller-tile-view-container"}>
          <div className="flex-container flex-horizontal flex-height header-container align-center">
            <div className="flex-container flex-vertical flex-width">
              <h2>
                <span { ...dataPoint }>{name}</span>
              </h2>
              <p className="sub-text gray-text">{type} {accountNumber}</p>
            </div>
            <div className="set-width image-container justify-right">
              {logo}
            </div>
          </div>
          <div className="content-container">
            {props.children}
          </div>
      </div>
    );
  }